import anime from 'animejs';

let quizMyFlavour = () => {

    let module = {},
        quizHolder,
        questionOptionImage,
        answerSelector,
        parentContainerSelector,
        questionNumberAttribute,
        answerContainerSelector,
        optionNumberAttribute,
        optionNumberTitleAttribute,
        optionNumberPercentageAttribute,
        resultAttribute,
        resultSelector,
        mainProgressCircleSelector,
        progressCircleAttribute,
        progressCircleSelector,
        injectAnswerElement,
        injectPercentageElement,
        resultPercSelector,
        resultTitleSelector,
        nextButtonSelector,
        prevButtonSelector,
        finishButtonSelector,
        nextButton,
        prevButton,
        askContainerSelector,
        counterSelector,
        counter,
        counterSelectorLink,
        counterLink,
        totalPoints,
        scrollToTop = () => {
            $('html, body').stop().animate( {
                'scrollTop': 0
            }, 500);
        },
        /**
         * Triggers when you click on option image - .question-option-js (one of two images with blobs)
         */
        onOptionClick = () => {
            questionOptionImage.on('click', function (ev) {
                var $this = $(this);
                var parentContainer = $this.closest(parentContainerSelector);
                var questionNumber = parentContainer.attr(questionNumberAttribute);
                var answerContainer = $(answerContainerSelector + '-' + questionNumber);
                var optionNumber = $this.attr(optionNumberAttribute);
                showSelectedAnswer(answerContainer, optionNumber);
                scrollToTop();
            });
        },
        /**
         * Changes pagination counter txt with given numeral value
         */
        changeCounterNumber = (number) => {
            counterLink.html(number);
        },
        /**
         * Updates progress circle with values as percentage value, title and description
         * it substitutes X and Y values given through data
         * container - container of element "slide" that holds the whole answer
         */
        updateProgressCircle = (container, answerNr, percentage) => {
            var circleContainer = container.find(progressCircleSelector);
            var mainCircle = container.find(mainProgressCircleSelector);
            var answerTitle = container.find(resultSelector + '.active .answer-title').html();
            mainCircle.attr(progressCircleAttribute, percentage);
            container.find(resultPercSelector).html(percentage + ' %');
            container.find(resultTitleSelector).html(answerTitle);
            container.find('.result__desc').html(container.find('.result__desc').html().replace(injectPercentageElement, percentage));
            container.find('.result__desc').html(container.find('.result__desc').html().replace(injectAnswerElement, answerTitle));
        },
        /**
         * Triggers when you click one of the next buttons - next-btn-js
         */
        onNextClick = () => {
            nextButton.on('click', function (ev) {
                /* var $this = $(this);
                var questionNr = $this.closest(parentContainerSelector).attr(questionNumberAttribute);
                setActiveSection((parseInt(questionNr) + 1)); */
                setNextSectionAsActive();
                scrollToTop();
            });
        },
        /**
         * Triggers when you click one of the prev buttons - prev-btn-js
         */
        onPrevClick = () => {
            prevButton.on('click', function (ev) {
                /*var $this = $(this);
                var questionNr = $this.closest(parentContainerSelector).attr(questionNumberAttribute);
                setActiveSection((parseInt(questionNr) - 1));*/
                setPrevSectionAsActive();
                scrollToTop();
            });
        },
        /**
         * Sets active question section. (Not question answer section, but sets section of question-ask)
         */
        setActiveSection = (nr) => {
            var activeSection = $(askContainerSelector + '[' + questionNumberAttribute + '="' + nr + '"]');
            if (activeSection.length) {
                $(parentContainerSelector).removeClass('active');
                activeSection.addClass('active');
                changeCounterNumber(nr);
            }
        },
        /**
         * Gets current active question-ask section
         */
        getCurrentActiveSection = () => {
            var currentActiveSection = $(parentContainerSelector + '.active');
            if (!currentActiveSection.length == 1) {
                return null;
            }
            return currentActiveSection;
        },
        /**
         * Gets current active question-ask section number
         */
        getCurrentActiveSectionNumber = () => {
            return getCurrentActiveSection().attr(questionNumberAttribute);
        },
        /**
         * Sets next question-ask section as active if it exists
         */
        setNextSectionAsActive = () => {
            var currentActiveSectionNumber = getCurrentActiveSectionNumber();
            if (currentActiveSectionNumber) {
                setActiveSection(parseInt(currentActiveSectionNumber) + 1);
            }
        },
        /**
         * Sets previous question-ask section as active if it exists
         */
        setPrevSectionAsActive = () => {
            var currentActiveSectionNumber = getCurrentActiveSectionNumber();
            if (currentActiveSectionNumber) {
                setActiveSection(parseInt(currentActiveSectionNumber) - 1);
            }
        },
        /**
         * Shows picked result, after you clicked on option image
         */
        showSelectedAnswer = (container, answerNr) => {
            // Send AJAX request with the selected answer
            jQuery.post(
                window.location.origin + '/wp/wp-admin/admin-ajax.php', {
                    'action': 'mytaste',
                    'question': container.data('question-nr') ,
                    'answer': answerNr,
                    'site_id': $('#site_id').text(),
                    'nonce': $('#nonce').text(),
                    'identifier': $('#identifier').text(),
                }
            );

            $(parentContainerSelector).removeClass('active');
            container.find(resultSelector).removeClass('active');
            var selectedOptionContainer = container.find('[' + optionNumberAttribute + '="' + answerNr + '"]');
            selectedOptionContainer.addClass('active');

            // Set selected title
            container.find('[' + optionNumberTitleAttribute + '="' + answerNr + '"]').removeClass('d-none');

            // Get percentage
            var percentage = +(container.find('[' + optionNumberPercentageAttribute + '="' + answerNr + '"]').text());

            if (percentage >= 50) {
                totalPoints += 1;
            }

            switch(totalPoints) {
                case 0:
                case 1:
                case 2:
                    $(finishButtonSelector).addClass('d-none');
                    $(finishButtonSelector+'[data-range="1"]').removeClass('d-none');
                    break;
                case 3:
                case 4:
                    $(finishButtonSelector).addClass('d-none');
                    $(finishButtonSelector+'[data-range="2"]').removeClass('d-none');
                    break;
                case 5:
                case 6:
                    $(finishButtonSelector).addClass('d-none');
                    $(finishButtonSelector+'[data-range="3"]').removeClass('d-none');
                    break;
                default:
                    $(finishButtonSelector).addClass('d-none');
                    $(finishButtonSelector+'[data-range="4"]').removeClass('d-none');
            }

            container.addClass('active');
            updateProgressCircle(container, answerNr, percentage);
        },
        /**
         * Init function. triggers on document load. If there isn't quiz returns void;
         */
        init = () => {
            if (!$('.quiz-myflavour-js').length) {
                return;
            }
            quizHolder = $('.quiz-myflavour-js');
            questionOptionImage = $('.question-option-js');
            answerSelector = '.result-option';
            parentContainerSelector = '.question-part';
            askContainerSelector = '.question-ask';
            answerContainerSelector = '.question-answer';
            questionNumberAttribute = 'data-question-nr';
            optionNumberAttribute = 'data-option-nr';
            optionNumberTitleAttribute = 'data-option-title-nr';
            optionNumberPercentageAttribute = 'data-option-percentage-nr';
            resultSelector = '.result-option';
            progressCircleSelector = '.progress-circle';
            mainProgressCircleSelector = '.progress-circle__mainc';
            progressCircleAttribute = 'data-progress';
            injectPercentageElement = '{percentage}';
            injectAnswerElement = '{answer}';
            resultPercSelector = '.result__perc';
            resultTitleSelector = '.result__title';
            resultAttribute = optionNumberAttribute;
            nextButtonSelector = '.next-btn-js';
            prevButtonSelector = '.prev-btn-js';
            finishButtonSelector = '.finish-btn-js';
            nextButton = $(nextButtonSelector);
            prevButton = $(prevButtonSelector);
            counterSelector = '.counter-js';
            counterSelectorLink = counterSelector + '>a>span';
            counterLink = $(counterSelectorLink);
            counter = $(counterSelector);
            totalPoints = 0;

            setActiveSection(1);
            onOptionClick();
            onNextClick();
            onPrevClick();
        };

    module.init = init;

    return module;

};

export default quizMyFlavour();